import { useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import './BasicData.scss';

import B4EmissionFactors from './B4EmissionFactors/B4EmissionFactors';
import B6CarbonCaptureandStorage from './B6CarbonCaptureandStorage/B6CarbonCaptureandStorage';
import B5SlippageCoefficient from './B5SlippageCoefficient/B5SlippageCoefficient';
import B1ShipDetails from './B1ShipDetails/B1ShipDetails';
import B2CompanyInformation from './B2CompanyInformation/B2CompanyInformation';
import B3EmissionSources from './B3EmissionSources/B3EmissionSources';
import B7EmissionSources from './B7EmissionSources/B7EmissionSources';
import B8EmissionfactorsAnnex1 from './B8EmissionfactorsAnnex1/B8EmissionfactorsAnnex1';
import B9EmissionfactorsAnnex2 from './B9EmissionfactorsAnnex2/B9EmissionfactorsAnnex2';

const BasicData = ({ data, dropdownData, refetchMonitoringData ,vesselMstId}) => {
    const [expandedPanel, setExpandedPanel] = useState('panel1');
    const methods = useForm({
        mode: 'onBlur',
        defaultValues: {},
    });

    useEffect(() => {
        if (data) {
            if (expandedPanel === 'panel1') {
                methods.reset({
                    ...data?.b1ShipIdentification
                });
            }
            else if (expandedPanel === 'panel3') {
                methods.reset({
                    ...data?.b3EmissionSources,
                })
            } 
            else {
                methods.reset({
                    ...data?.b2CompanyInfo,
                    b7: data?.b7EmissionSourceCompleteness || {},
                    b8: data?.b8EmissionFactorProcedure || {},
                    b9: data?.b9BiofuelEmissionFactor || {}
                });
            }
        }
    }, [data, expandedPanel, methods]);

    //autosave implementation
    const autoSaveForB1 = useRef();
    const autoSaveForB2 = useRef();
    const autoSaveForB3 = useRef();
    const autoSaveForB4 = useRef();
    const autoSaveForB5 = useRef();
    const autoSaveForB6 = useRef();
    const autoSaveForB7 = useRef();
    const autoSaveForB8 = useRef();
    const autoSaveForB9 = useRef();

    const handleChange = (panel) => async (_, isExpanded) => {
        let isSubmitSuccess = true;
        if (expandedPanel === 'panel1' && autoSaveForB1.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB1.current.submitAndCheck();
        } else if (expandedPanel === 'panel2' && autoSaveForB2.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB2.current.submitAndCheck();
        } else if (expandedPanel === 'panel3' && autoSaveForB3.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB3.current.submitAndCheck();
        } else if (expandedPanel === 'panel4' && autoSaveForB4.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB4.current.submitAndCheck();
        } else if (expandedPanel === 'panel5' && autoSaveForB5.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB5.current.submitAndCheck();
        } else if (expandedPanel === 'panel6' && autoSaveForB6.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB6.current.submitAndCheck();
        } else if (expandedPanel === 'panel7' && autoSaveForB7.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB7.current.submitAndCheck();
        } else if (expandedPanel === 'panel8' && autoSaveForB8.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB8.current.submitAndCheck();
        } else if (expandedPanel === 'panel9' && autoSaveForB9.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB9.current.submitAndCheck();
        }
        if (!isSubmitSuccess) return;
        setExpandedPanel(isExpanded ? panel : false);
    };

    const renderTitleWithIcon = (panel, title) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {expandedPanel === panel ? '−' : '+'}
            </span>
            <p className="fuel-cons">{title}</p>
        </div>
    );
       const b1ShipFormMethods = useForm();
     const b2CompanyFormMethods = useForm();

    return (
        <FormProvider {...methods}>
            <form>
                <Accordion defaultExpanded expanded={expandedPanel === 'panel1'} onChange={handleChange('panel1')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel1', 'B.1 Identification of the ship and shipowner details')}
                    </AccordionSummary>
                    <AccordionDetails>
                         <FormProvider {...b1ShipFormMethods}>
                        <B1ShipDetails ref={autoSaveForB1} B1ShipDetailsData={data?.b1ShipIdentification} B1ShipDropdownValues={dropdownData} refetchMonitoringData={refetchMonitoringData} vesselMstId={vesselMstId}/>
                        </FormProvider>  
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expandedPanel === 'panel2'} onChange={handleChange('panel2')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel2', 'B.2 Company information')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormProvider {...b2CompanyFormMethods}>
                        <B2CompanyInformation ref={autoSaveForB2} vesselMstId={vesselMstId} b2CompanyInfo={data?.b2CompanyInfo} b2CompanyInfoValues={dropdownData?.companyNatures} refetchMonitoringData={refetchMonitoringData} /></FormProvider></AccordionDetails>
                </Accordion>
                <Accordion expanded={expandedPanel === 'panel3'} onChange={handleChange('panel3')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel3', 'B.3 Emission sources and fuel types used')}
                    </AccordionSummary>
                    <AccordionDetails><B3EmissionSources ref={autoSaveForB3} vesselMstId={vesselMstId} b3EmissionSourcesData={data?.b3EmissionSources} b3EmissionSourcesValues={dropdownData} refetchMonitoringData={refetchMonitoringData} /></AccordionDetails>
                </Accordion>
                <Accordion expanded={expandedPanel === 'panel4'} onChange={handleChange('panel4')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel4', 'B.4 Emission factors referred to in Annex I to Regulation (EU) 2015/757')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <B4EmissionFactors
                            b4EmissionFactors={data?.b4EmissionFactors}
                            fuelOriginMsts={dropdownData?.fuelOrigins}
                            vesselMstId={vesselMstId}
                            refetchMonitoringData={refetchMonitoringData}
                            fuelBunkeredDensities={dropdownData?.fuelBunkeredDensities}
                            ref={autoSaveForB4}
                        /></AccordionDetails>
                </Accordion>
                <Accordion expanded={expandedPanel === 'panel5'} onChange={handleChange('panel5')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel5', 'B.5 Slippage coefficient referred to in Annex I to Regulation (EU) 2015/757')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <B5SlippageCoefficient
                            ref={autoSaveForB5}
                            vesselMstId={vesselMstId}
                            b5SlippageCoefficient={data?.b5SlippageCoefficient}
                            reasonForChanges={dropdownData?.reasonForChanges}
                            refetchMonitoringData={refetchMonitoringData}
                            shouldRefetch={expandedPanel === 'panel5'}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expandedPanel === 'panel6'} onChange={handleChange('panel6')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel6', 'B.6 Application of carbon capture and storage technologies referred to in Part C, point 1.4, of Annex II to Regulation (EU) 2015/757')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <B6CarbonCaptureandStorage
                        
                            b6CcsCcuData={data?.b6CarbonCaptureTechnologies}
                            vesselMstId={vesselMstId}
                            refetchMonitoringData={refetchMonitoringData}
                            shouldRefetch={expandedPanel === 'panel6'}
                            ref={autoSaveForB6}
                        /></AccordionDetails>
                </Accordion>
                <Accordion expanded={expandedPanel === 'panel7'} onChange={handleChange('panel7')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel7', 'B.7 Procedures, systems and responsibilities used to update the completeness of emission sources')}
                    </AccordionSummary>
                    <AccordionDetails><B7EmissionSources ref={autoSaveForB7} vesselMstId={vesselMstId} b7EmissionSourceData={data?.b7EmissionSourceCompleteness} refetchMonitoringData={refetchMonitoringData} /></AccordionDetails>
                </Accordion>
                <Accordion expanded={expandedPanel === 'panel8'} onChange={handleChange('panel8')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel8', 'B.8 Procedures, systems and responsibilities used to determine and update emission factors in accordance with Annex I to Regulation (EU) 2015/757')}
                    </AccordionSummary>
                    <AccordionDetails><B8EmissionfactorsAnnex1 ref={autoSaveForB8} vesselMstId={vesselMstId} b8EmissionFactorsData={data?.b8EmissionFactorProcedure} refetchMonitoringData={refetchMonitoringData} /></AccordionDetails>
                </Accordion>
                <Accordion expanded={expandedPanel === 'panel9'} onChange={handleChange('panel9')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel9', 'B.9 Procedure used to determine the CO2 emission factors of biofuels and RFNBOs/RCFs referred to in Part C, point 1.2, of Annex II to Regulation (EU) 2015/757')}
                    </AccordionSummary>
                    <AccordionDetails><B9EmissionfactorsAnnex2 ref={autoSaveForB9} vesselMstId={vesselMstId} b9FuelEmissionFactorsData={data?.b9BiofuelEmissionFactor} refetchMonitoringData={refetchMonitoringData} /></AccordionDetails>
                </Accordion>
            </form>
        </FormProvider>
    );
};

export default BasicData;
